import React, { useState } from "react";
import "./App.css";
import { ThemeProvider } from "./theme";
import Nav from "./components/nav/Nav.jsx";
import Homepage from "./components/homepage/homepage.jsx";
import SignIn from "./components/signIn/sign_in.jsx";
import SignUp from "./components/signUp/sign_up.jsx";
import Footer from "./components/footer/footer.jsx";
import Guidelines from "./components/guidelines/guidelines.jsx";
import ScrollToTop from "./components/nav/scrolltotop.jsx";
import CreateTag from "./components/makeTag/make_tag.jsx";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import SearchTag from "./components/searchTag/searchtag.jsx";
import RequiredAuth from "./components/signIn/RequireAuth.jsx";

function AnimatedRoutes({ token, handleToken, handleLogOut }) {
  const location = useLocation();

  return (
    <>
      <ScrollToTop />
      {/* Navbar is outside the animated div so it never flickers on navigation */}
      <Nav token={token} handleLogOut={handleLogOut} />
      {/* key forces remount on every route change, restarting the CSS animation */}
      <div key={location.key} style={{ animation: "pageFadeIn 0.18s ease both" }}>
        <Routes>
          <Route path="/"            element={<><Homepage /><Footer /></>} />
          <Route path="/login"       element={<SignIn handleToken={handleToken} />} />
          <Route path="/signup"      element={<SignUp handleToken={handleToken} />} />
          <Route path="/guidelines"  element={<><Guidelines /><Footer /></>} />
          <Route path="/search-tags" element={<><SearchTag /><Footer /></>} />
          {/* /testingzone removed — test.jsx imports uninstalled MUI */}
          <Route element={<RequiredAuth />}>
            <Route path="/make-a-tag" element={<CreateTag />} />
          </Route>
        </Routes>
      </div>
    </>
  );
}

function App() {
  const [token, setToken] = useState(
    localStorage.getItem("token") || ""
  );

  const handleToken = (e) => {
    setToken(e);
    localStorage.setItem("token", e);
  };

  const handleLogOut = () => setToken("");

  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <AnimatedRoutes
            token={token}
            handleToken={handleToken}
            handleLogOut={handleLogOut}
          />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
